<template>
    <div class="basic-setting-content pl16 pr16">
        <!--基本信息-->
        <div class="common-form">法人信息</div>

        <el-form-item label="法人姓名" :rules="[{required: true,message: '请输入法人姓名'}]">
            <el-input v-model="formData.legalPersonName" placeholder="请输入企业名称" class="max-w460" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="证件类型" :rules="[{required: true,message: '请选择证件类型'}]">
            <el-radio-group v-model="formData.legalPersonCerType">

            </el-radio-group>
        </el-form-item>
        <el-form-item label="证件号码" :rules="[{required: true,message: '请输入证件号码'}]">
            <el-input v-model="formData.legalPersonCerNum" placeholder="请输入证件号码" class="max-w460" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="证件有效开始日期" :rules="[{required: true,message: '请输入证件有效开始日期'}]">
            <el-input v-model="formData.idValidateStart" placeholder="请输入证件有效开始日期" class="max-w460" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="证件有效截止日期" :rules="[{required: true,message: '请输入证件有效截止日期'}]">
            <el-input v-model="formData.idValidateEnd" placeholder="请输入证件有效截止日期" class="max-w460" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="法人手机号码" :rules="[{required: true,message: '请输入法人手机号码'}]">
            <el-input v-model="formData.legalPersonPhone" placeholder="请输入法人手机号码" class="max-w460" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="统一信用证" :rules="[{required: true,message: '请输入统一信用证'}]">
            <el-input v-model="formData.unifiedSocialCreditFileId" placeholder="请输入统一信用证" class="max-w460" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="法人身份证（肖像面）" :rules="[{required: true,message: '选择法人身份证（肖像面）'}]">
            <!--<el-button @click="chooseImg('business')">选择营业执照</el-button>-->
            <div class="img">
                <img :src="formData.legpCerFrontFileId" width="100" height="100"/>
            </div>
        </el-form-item>
        <el-form-item label="法人身份证（国徽面）" :rules="[{required: true,message: '选择法人身份证（国徽面）'}]">
            <!--<el-button @click="chooseImg('business')">选择营业执照</el-button>-->
            <div v-if="formData.business_id!=''" class="img">
                <img :src="formData.legpCerBackFileId" width="100" height="100"/>
            </div>
        </el-form-item>

        <!--上传图片-->
        <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc"></Upload>
    </div>
</template>

<script>
    import Upload from '@/components/file/Upload';

    export default {
        components: {
            Upload,
        },
        data() {
            return {
                // 是否打开图片选择
                isupload: false,
                // 当前图片类别
                type: null,
                logo_file_path: '',
                business_file_path: '',
            }
        },
        inject: ['formData'],
        watch: {

        },
        created() {

        },
        methods: {
            // 选择图片
            chooseImg(e) {
                this.type = e;
                this.isupload = true;
            },

            // 关闭选择图片
            returnImgsFunc(e) {
                if (e != null && e.length > 0) {
                    if (this.type == 'logo') {
                        this.logo_file_path = e[0].file_path;
                        this.formData.logo_id = e[0].file_id;
                    } else if (this.type == 'business') {
                        this.business_file_path = e[0].file_path;
                        this.formData.business_id = e[0].file_id;
                    }
                }
                this.isupload = false;
            }
        }
    }
</script>

<style scoped>
    .img{
        margin-top: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/views/setting/supplier/part/Legal.vue